import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import Button from "../../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../../Reusable/BaseURL";
import MyTextarea from "../../../Reusable/MyTextarea";
import MyInput from "../../../Reusable/MyInput";
import { useNavigate } from "react-router-dom";
import GatePassPageForm from "./GatePassPageForm";
import { GatePassTypeSelect } from "./GatePassTypeSelect";
import { GatePassPOSelect } from "./GatePassPOSelect";
import { GatePassOutTypeSelect } from "./GatePassOutTypeSelect";
import { GatePassInTypeSelect } from "./GatePassInTypeSelect";
import { GatePassPartySelect } from "./GatePassPartySelect";
import DirectGPCreateForm from "./gpDirectTypeForm/DirectGPCreateForm";
import { GatePassRGPSelect } from "./GatePassRGPSelect";
import GatePassRGPPageForm from "./GatePassRGPPageForm";
import { GatePassNRGPSelect } from "./GatePassNRGPSelect";
import GatePassNRGPPageForm from "./GatePassNRGPPageForm";

export default function GatePass() {
  // CHANGE PO-TYPE CONFIRMATION
  // async function Check() {
  //   await getUnsavedItemList();
  //   if (unsavedIndentItem.length > 0) {
  //     showDialog();
  //   } else {
  //     setCacheTypeFun();
  //   }
  // }
  // const showDialog = () => {
  //   confirmAlert({
  //     customUI: ({ onClose }) => {
  //       return (
  //         <CustomConfirmDialog
  //           title="In Direct-PO: Your Added Items are listed !"
  //           message="If You Choose 'YES' Direct-PO-Items will be Removed."
  //           onConfirm={() => {
  //             const changeConfirm = async () => {
  //               setCacheTypeFun();
  //             };
  //             changeConfirm();
  //             onClose();
  //           }}
  //           onCancel={onClose}
  //         />
  //       );
  //     },
  //   });
  // };
  // close check division change

  const {
    darkTheme,
    loginData,
    indentAddItemLoading,
    setIndentCreateItemId4Upd,
    setGatePassListData,
    gatePassListData,
  } = useContext(UserContext);

  const [gatePassType, setGatePassType] = useState("");
  const [gatePassOutType, setGatePassOutType] = useState("");
  const [gatePassInType, setGatePassInType] = useState("");
  const [gpRgp, setGpRgp] = useState("");
  const [gpNrgp, setGpNrgp] = useState("");
  const [gateNo, setGateNo] = useState("");
  const [choosePO, setChoosePO] = useState("");
  const [party, setParty] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [visitorName, setVisitorName] = useState("");
  const [mobile, setMobile] = useState("");
  const [date, setDate] = useState("");
  const [remark, setRemark] = useState("");
  const [challan, setChallan] = useState("");
  const [partyDetail, setPartyDetail] = useState("");
  const [poItemCheckBoxId, setPOItemCheckBoxId] = useState([]);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(false); // set: true default imp.

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [itemSubmitDisable, setItemSubmitDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);
  const [allIndentItem, setAllIndentItem] = useState([]);
  const [cacheItemId, setCacheItemId] = useState("");
  const [myCacheDivision, setMyCacheDivision] = useState("");
  const [myCachePartyId, setMyCachePartyId] = useState("");

  const navigate = useNavigate();
  // useEffect(()=>{getUnsavedItemList()},[])

  // GATE PASS : SET CACHE function
  async function setCacheFun() {
    const selectedData = {
      // "type": gatePassType.label || "",
      //   "subtype": gatePassInType.label || "",
      challan_no: challan || "",
      // "party_id": choosePO.party_id || "",
      gate_no: gateNo || "",
      vehicle_no: vehicleNo || "",
      person_name: visitorName || "",
      mobile_no: mobile || "",
      remarks: remark || "",
    };
    // return console.log("cache data", selectedData)
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    // const data = await response.json();
  }

  // GATE PASS : TYPE SET CACHE
  async function setCacheTypeFun(type) {
    const selectedData = { type: type.label };
    // return console.log("typpe", selectedData)
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }

  // GATE PASS : Sub- TYPE SET CACHE
  async function setCacheInTypeFun(inType) {
    const inTypeLabel = inType.label || gatePassInType.label;
    const selectedData = { subtype: inTypeLabel };
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // GATE PASS : Sub- TYPE SET CACHE
  async function setCacheOutTypeFun(inType) {
    const inTypeLabel = inType.label || gatePassOutType.label;
    const selectedData = { subtype: inTypeLabel };
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // GATE PASS : po SET CACHE function
  async function setCachePOFun(po) {
    const selectedData = { party_id: po.party_id || po.value };
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // GATE PASS : RGP SET CACHE function
  async function setCacheRgpFun(selectedIds) {
    const ids = [selectedIds];
    const formData = {
      rgp_ids: ids,
    };
    const response = await fetch(`${BaseURL}/purchase/gp/setcachergps`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
  }
  // GATE PASS : NRGP SET CACHE function
  async function setCacheNRgpFun(selectedIds) {
    const ids = [selectedIds];
    // console.log("checked id", checkedIds)
    const formData = {
      nrgp_ids: ids,
    };
    const response = await fetch(`${BaseURL}/purchase/gp/setcachenrgps`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
  }
  // GATE PASS : NRGP SET CACHE function
  async function setCacheNrgpFun() {
    const formData = {
      nrgp_ids: [1, 2],
    };
    const response = await fetch(`${BaseURL}/purchase/gp/setcachenrgps`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
  }
  // // OnBlur DATE
  // async function postCacheItemDate() {
  //   const selectedData = { date: date };
  //   const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(selectedData),
  //   });
  //   const data = await response.json();
  // }
  // OnBlur REMARK
  async function postCacheItemRemark() {
    const selectedData = { remarks: remark };
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }

  // async function getUnsavedCache() {
  //   setInitialLoading(true);
  //   const res = await fetch(`${BaseURL}/purchase/gp/getcache`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         // const cacheItems = createRes.data.items || [];
  //         // const poType = createRes.data.type;
  //         setPOTypeCheck(createRes.data);
  //         const cacheItems =
  //           createRes.data !== null ? createRes.data.items : [];
  //         setUnsavedIndentItem(cacheItems);

  //         setSpinner(false);
  //       }
  //       if (createRes.status || createRes.status === false) {
  //         setInitialLoading(false);
  //         setSpinner(false);
  //       } else {
  //         setInitialLoading(false);
  //         setSpinner(false);
  //       }
  //     });
  // }
  async function getUnsavedItemList() {
    // setInitialLoading(true);
    const res = await fetch(`${BaseURL}/purchase/gp/getcache`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then(async (createRes) => {
        if (createRes.status) {
          // const cacheItems = createRes.data.items || [];

          // setPOTypeCheck(createRes.data);
          const cacheItems =
            createRes.data !== null ? createRes.data.items : [];
          // const reverseCacheItems = cacheItems.reverse();
          // setUnsavedIndentItem(createRes.data.items || []);
          setUnsavedIndentItem(cacheItems);
          // await setIndentPOCache(cacheItems);

          // const mygetdivision = createRes.data?.items[0];
          // const cacheDivision = mygetdivision.division;
          // setMyCacheDivision(cacheDivision || "");

          // const mygetdivision =
          //   createRes.data !== null ? createRes.data?.items[0] : {};
          // const cacheDivision = mygetdivision?.division || "";
          // setMyCacheDivision(cacheDivision || "");

          if (createRes?.data?.items > 0) {
            // const myCacheDiv = createRes?.data?.division;
            // const myCacheDate = createRes?.data?.date;
            // setMyCacheDivision(myCacheDiv || "");
            // setDate(myCacheDate || "");
            const myCachePId = createRes?.data?.party_id;
            const myCacheChallan = createRes?.data?.challan_no;
            const myCacheType = createRes?.data?.type;
            const myCacheSubtype = createRes?.data?.subtype;
            const myCacheGateNo = createRes?.data?.gate_no;
            const myCacheVehicleNo = createRes?.data?.vehicle_no;
            const myCachePersonName = createRes?.data?.person_name;
            const myCacheMobile = createRes?.data?.mobile_no;
            const myCacheRemark = createRes?.data?.remarks;

            setMyCachePartyId(myCachePId || "");
            setChallan(myCacheChallan || "");
            setGatePassType(myCacheType || "");
            setGatePassInType(myCacheSubtype || "");
            setGateNo(myCacheGateNo || "");
            setVehicleNo(myCacheVehicleNo || "");
            setVisitorName(myCachePersonName || "");
            setMobile(myCacheMobile || "");
            setRemark(myCacheRemark || "");
          }
          setSpinner(false);
        }
        if (createRes.status || createRes.status === false) {
          // setInitialLoading(false);
          setSpinner(false);
        } else {
          // setInitialLoading(false);
          setSpinner(false);
        }
      });
  }
  // async function getAllIndentCreated() {
  //   const res = await fetch(`${BaseURL}/purchase/indent/getall`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         setAllIndentItem(createRes.data);
  //         setSpinner(false);
  //       }
  //     });
  // }

  useEffect(() => {
    // getAllIndentCreated();
    // getUnsavedItemList();
  }, []);

  // ADD INDENT ITEM
  // async function addIndentItem(e) {
  //   e.preventDefault();
  //   // const formData = new FormData();
  //   // formData.append("item_id", item.value || "");
  //   // formData.append("brand_id", brand.value || "");
  //   // formData.append("unit_id", unit.value || "");
  //   // formData.append("qty", qty || "");

  //   const unitRateAfterDiscount = parseFloat(netAmount) / parseFloat(qty);
  //   // console.log("unitRate a|fater discount", unitRateAfterDiscount.toFixed(2))

  //   if (division !== "") {
  //     setItemSubmitDisable(true);
  //     const formData = {
  //       item_id: item.value || "",
  //       brand_id: brand.brand_id || "",
  //       unit_id: unit.value || "",
  //       qty: qty || 0,
  //       party_id: poPartySelect.value || "",
  //       unit_rate: unitAmount || 0,
  //       amount: finalAmount || 0,
  //       discount: discount || 0,
  //       unit_rate_after_discount: unitRateAfterDiscount.toFixed(2) || 0,
  //       final_amount: netAmount || 0,
  //     };

  //     const res = await fetch(`${BaseURL}/purchase/po/setcacheitems`, {
  //       method: "POST",
  //       body: JSON.stringify(formData),
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${loginData.token}`,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //       .then((resdata) => resdata.json())
  //       .then((createRes) => {
  //         if (createRes.status) {
  //           setAddMoreToggle(false);
  //           getUnsavedItemList();
  //           setItem("");
  //           setBrand("");
  //           setUnit("");
  //           setQty(0);

  //           setUnitAmount(0);
  //           setDiscount(0);
  //           setNetAmount(0);
  //           setFinalAmount(0);
  //           toast.success("Added on lists");
  //           setItemSubmitDisable(false);
  //         }
  //         if (createRes.status === false) {
  //           setItemSubmitDisable(false);
  //         }
  //         if (createRes?.error?.message.item_id) {
  //           toast.error(createRes.error.message.item_id);
  //         } else if (createRes?.error?.message.brand_id) {
  //           toast.error(createRes.error.message.brand_id);
  //         } else if (createRes?.error?.message.unit) {
  //           toast.error(createRes.error.message.unit);
  //         } else if (createRes?.error?.message.qty) {
  //           toast.error(createRes.error.message.qty);
  //         } else if (createRes?.error?.message.discount) {
  //           toast.error(createRes.error.message.discount);
  //         }
  //       });
  //   } else {
  //     toast.error("First Select Division.!");
  //     setItemSubmitDisable(false);
  //   }
  // }

  // create
  async function createDivision(e) {
    e.preventDefault();
    // const poItemIds = gatePassListData?.map((item) => item.id);
    //  return console.log("poItemIds", poItemCheckBoxId)

    if (gatePassListData.length <= 0) {
      toast.error("Please Select PO before submit.");
      return;
    }
    setSubmitDisable(true);

    const formData = {
      type: gatePassType.label,
      subtype: gatePassInType.label,
      party_id: choosePO.party_id,
      challan_no: challan,
      gate_no: gateNo,
      vehicle_no: vehicleNo,
      person_name: visitorName,
      mobile_no: mobile,
      remarks: remark,
      po_item_ids: poItemCheckBoxId,
    };

    const res = await fetch(`${BaseURL}/purchase/gp/createpopass`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          toast.success("Success");

          setGatePassType("");
          setGateNo("");
          setChallan("");
          setVehicleNo("");
          setVisitorName("");
          setMobile("");
          setChoosePO("");
          setDate("");
          setRemark("");

          // navigate("/purchase/indent-po-view");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.gate_no) {
          toast.error(createRes.error.message.gate_no);
        } else if (createRes?.error?.message.vehicle_no) {
          toast.error(createRes.error.message.vehicle_no);
        } else if (createRes?.error?.message.person_name) {
          toast.error(createRes.error.message.person_name);
        } else if (createRes?.error?.message.mobile_no) {
          toast.error(createRes.error.message.mobile_no);
        } else if (createRes?.error?.message.po_item_ids) {
          toast.error(createRes.error.message.po_item_ids);
        } else if (createRes?.error?.message.items) {
          toast.error(createRes.error.message.items);
        } else if (createRes?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }

  // GP : RGP - SUBMIT
  async function rgpSubmitFuc(e) {
    e.preventDefault();
    // const poItemIds = gatePassListData?.map((item) => item.id);
    //  return console.log("poItemIds", poItemCheckBoxId)

    if (gatePassListData.length <= 0) {
      toast.error("Please list items before submit.");
      return;
    }
    setSubmitDisable(true);

    const formData = {
      type: gatePassType.label,
      subtype: gatePassOutType.label,
      party_id: gpRgp.party_id,
      challan_no: challan,
      gate_no: gateNo,
      vehicle_no: vehicleNo,
      person_name: visitorName,
      mobile_no: mobile,
      remarks: remark,
      rgp_item_ids: poItemCheckBoxId,
    };
    //  return console.log("formData", formData)

    const res = await fetch(`${BaseURL}/purchase/gp/creatergppass`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          toast.success("Success");

          setGatePassType("");
          setGpRgp("");
          setGateNo("");
          setChallan("");
          setVehicleNo("");
          setVisitorName("");
          setMobile("");
          setChoosePO("");
          setDate("");
          setRemark("");

          // navigate("/purchase/pending-gp-view");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.gate_no) {
          toast.error(createRes.error.message.gate_no);
        } else if (createRes?.error?.message.vehicle_no) {
          toast.error(createRes.error.message.vehicle_no);
        } else if (createRes?.error?.message.person_name) {
          toast.error(createRes.error.message.person_name);
        } else if (createRes?.error?.message.mobile_no) {
          toast.error(createRes.error.message.mobile_no);
        } else if (createRes?.error?.message.rgp_item_ids) {
          toast.error(createRes.error.message.rgp_item_ids);
        } else if (createRes?.error?.message.items) {
          toast.error(createRes.error.message.items);
        } else if (createRes?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }
  // NRGP SUBMIT FUN
  async function nrgpSubmitFuc(e) {
    e.preventDefault();
    // const poItemIds = gatePassListData?.map((item) => item.id);
    //  return console.log("poItemIds", poItemCheckBoxId)

    if (gatePassListData.length <= 0) {
      toast.error("Please list items before submit.");
      return;
    }
    setSubmitDisable(true);

    const formData = {
      type: gatePassType.label,
      subtype: gatePassOutType.label,
      party_id: gpNrgp.party_id,
      challan_no: challan,
      gate_no: gateNo,
      vehicle_no: vehicleNo,
      person_name: visitorName,
      mobile_no: mobile,
      remarks: remark,
      nrgp_item_ids: poItemCheckBoxId,
    };

    const res = await fetch(`${BaseURL}/purchase/gp/createnrgppass`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          toast.success("Success");

          setGatePassType("");
          setGpRgp("");
          setGateNo("");
          setChallan("");
          setVehicleNo("");
          setVisitorName("");
          setMobile("");
          setChoosePO("");
          setDate("");
          setRemark("");

          // navigate("/purchase/indent-po-view");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.gate_no) {
          toast.error(createRes.error.message.gate_no);
        } else if (createRes?.error?.message.vehicle_no) {
          toast.error(createRes.error.message.vehicle_no);
        } else if (createRes?.error?.message.person_name) {
          toast.error(createRes.error.message.person_name);
        } else if (createRes?.error?.message.mobile_no) {
          toast.error(createRes.error.message.mobile_no);
        } else if (createRes?.error?.message.nrgp_item_ids) {
          toast.error(createRes.error.message.nrgp_item_ids);
        } else if (createRes?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }

  // START DIRECT GATE PASS CREATE
  async function createDirectGP(e) {
    e.preventDefault();
    const poItemIds = gatePassListData?.map((item) => item.id);
    // console.log("poItemIds", poItemIds)

    // if (gatePassListData.length <= 0) {
    //   toast.error("Please Choose PO list before submit.");
    //   return;
    // }
    setSubmitDisable(true);

    const formData = {
      type: gatePassType.label,
      subtype: gatePassInType.label,
      party_id: party.value,
      challan_no: challan,
      gate_no: gateNo,
      vehicle_no: vehicleNo,
      person_name: visitorName,
      mobile_no: mobile,
      remarks: remark,
    };

    const res = await fetch(`${BaseURL}/purchase/gp/createdirectpass`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          getUnsavedItemList();
          toast.success("Success");

          setGatePassType("");
          setGatePassInType("");
          setParty("");
          setGateNo("");
          setChallan("");
          setVehicleNo("");
          setVisitorName("");
          setMobile("");
          // setChoosePO("");
          // setDate("");
          setRemark("");

          // navigate("/purchase/indent-po-view");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.gate_no) {
          toast.error(createRes.error.message.gate_no);
        } else if (createRes?.error?.message.vehicle_no) {
          toast.error(createRes.error.message.vehicle_no);
        } else if (createRes?.error?.message.person_name) {
          toast.error(createRes.error.message.person_name);
        } else if (createRes?.error?.message.mobile_no) {
          toast.error(createRes.error.message.mobile_no);
        } else if (createRes?.error?.message.items) {
          toast.error(createRes.error.message.items);
        } else if (createRes?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }
  // END DIRECT GATE PASS CREATE

  // Listing record
  // function firstPageList(url = `${BaseURL}/states?page=1`) {
  //   setSpinner(true);
  //   fetch(url, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((li) => {
  //       if (li?.status) {
  //         const revData = li.data.data.reverse();
  //         setFirstPage(revData);
  //         setTotalNo(li.data.total);
  //         setFrom(li.data.from);
  //         setTo(li.data.to);
  //         setLinks(li.data.links);
  //         setSpinner(false);
  //       }
  //     });
  // }

  function editBtn(id) {
    setEditDisable(true);
    fetch(`${BaseURL}/purchase/po/getcacheitem/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          setChangingSelect(true);
          setAddMoreToggle(true);
          setSubmitAction("update");

          // setDivision(selectedRecord.data.division || "");
          setEditDisable(false);
          toast.success("Go to update form")
        }
        if (selectedRecord.status === false) {
          setEditDisable(false);
        }
      });
    setChangingSelect(false);
  }
  // UPDATE A RECORD
  // async function updateIndentItem(e, id) {
  //   e.preventDefault();
  //   setUpdateDisable(true);
  //   if (division !== "") {
  //     const unitRateAfterDiscount = parseFloat(netAmount) / parseFloat(qty);

  //     const formData = {
  //       item_id: item.value || "",
  //       brand_id: brand.brand_id || "",
  //       unit_id: unit.value || "",
  //       qty: qty || "",
  //       party_id: poPartySelect.value || "",
  //       unit_rate: unitAmount || "",
  //       amount: finalAmount || "",
  //       discount: discount || "",
  //       unit_rate_after_discount: unitRateAfterDiscount.toFixed(2) || "",
  //       final_amount: netAmount || "",
  //     };
  //     const updRes = await fetch(
  //       `${BaseURL}/purchase/po/updatecacheitem/${id}`,
  //       {
  //         method: "PATCH",
  //         body: JSON.stringify(formData),
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: `Bearer ${loginData.token}`,
  //           "Content-Type": "application/json",
  //         },
  //         // body: JSON.stringify({name: divisionName}),
  //       }
  //     )
  //       .then((res) => res.json())
  //       .then((upd) => {
  //         if (upd.status) {
  //           getUnsavedItemList();
  //           setGetId(0);
  //           setItem("");
  //           setBrand("");
  //           setUnit("");
  //           setQty(0);

  //           setUnitAmount(0);
  //           setDiscount(0);
  //           setNetAmount(0);
  //           setFinalAmount(0);

  //           setSubmitAction("submit");
  //           setAddMoreToggle(false);
  //           toast.success("Updated");
  //           setUpdateDisable(false);
  //         }
  //         if (upd.status === false) {
  //           setUpdateDisable(false);
  //         }
  //         if (upd?.error?.message.item_id) {
  //           toast.error(upd.error.message.item_id);
  //         } else if (upd?.error?.message.brand) {
  //           toast.error(upd.error.message.brand);
  //         } else if (upd?.error?.message.unit) {
  //           toast.error(upd.error.message.unit);
  //         } else if (upd?.error?.message.qty) {
  //           toast.error(upd.error.message.qty);
  //         } else if (upd?.error?.message) {
  //           toast.error(upd.error.message);
  //         }
  //       });
  //   }
  // }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");

    setGatePassType("");
    setGateNo("");
    setVehicleNo("");
    setVisitorName("");
    setMobile("");
    setChoosePO("");
    setDate("");
    setRemark("");

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);

    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
  }

  useEffect(() => {
    setGatePassListData([]);
    setChoosePO("");
  }, [gatePassType?.label]);

  // GET PARTY DETAIL FUNC
  const getPartyDetailFun = async (partyId) => {
    const res = await fetch(`${BaseURL}/parties/${partyId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    });
    const data = await res.json();
    if (data.status) {
      setPartyDetail(data.data.name);
    } else {
      toast.error("Party Detail not found!");
    }
  };

  // GET PO ITEMS FUNC
  const getPOItemsFun = async (poId) => {
    setSpinner(true);
    setGatePassListData([]);
    // const poId= choosePO?.value;
    const formData = {
      po_ids: [poId],
    };
    const res = await fetch(`${BaseURL}/purchase/gp/getpos`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await res.json();
    const poItems = data?.data || [];
    const items = poItems.map((item, index) =>
      item.items.map((finalItem) => finalItem)
    );
    const myItemsArr = [...items[0]];
    setGatePassListData(myItemsArr);
    // console.log("itesssms", myItemsArr, items);
    // if(data.status){
    // }else{
    //   toast.error("Party Detail not found!")
    // }
    if (data.status || data.status === false) {
      setSpinner(false);
    } else {
      setSpinner(false);
    }
  };

  // GET RGP ITEMS FUNC
  const getRGPItemsFun = async (poId) => {
    setSpinner(true);
    setGatePassListData([]);
    // const poId= choosePO?.value;
    const formData = {
      rgp_ids: [poId],
    };
    const res = await fetch(`${BaseURL}/purchase/gp/getrgp`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await res.json();
    const poItems = data?.data || [];
    const items = poItems.map((item, index) =>
      item.items.map((finalItem) => finalItem)
    );
    const myItemsArr = [...items[0]];
    setGatePassListData(myItemsArr);
    // console.log("itesssms", myItemsArr, items);
    // if(data.status){
    // }else{
    //   toast.error("Party Detail not found!")
    // }
    if (data.status || data.status === false) {
      setSpinner(false);
    } else {
      setSpinner(false);
    }
  };
  // GET NRGP ITEMS FUNC
  const getNRGPItemsFun = async (poId) => {
    setSpinner(true);
    setGatePassListData([]);
    // const poId= choosePO?.value;
    const formData = {
      nrgp_ids: [poId],
    };
    const res = await fetch(`${BaseURL}/purchase/gp/getnrgp`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await res.json();
    const poItems = data?.data || [];
    const items = poItems.map((item, index) =>
      item.items.map((finalItem) => finalItem)
    );
    const myItemsArr = [...items[0]];
    setGatePassListData(myItemsArr);
    // console.log("itesssms", myItemsArr, items);
    // if(data.status){
    // }else{
    //   toast.error("Party Detail not found!")
    // }
    if (data.status || data.status === false) {
      setSpinner(false);
    } else {
      setSpinner(false);
    }
  };

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Gate Pass
          </div>
          <div className="mb-2">
            <div className="flex gap-x-2">
              {/* LEFT PART  */}
              <div className="px-2 w-full mb-2">
                <form>
                  <div className="grid grid-cols-2 gap-x-2 md:grid-cols-4">
                    <div className="mb-2 w-full">
                      <label>
                        Type <span className="text-red-500 font-bold">*</span>
                      </label>
                      <GatePassTypeSelect
                        selectedOption={gatePassType}
                        setSelectedOption={setGatePassType}
                        setCacheTypeFun={setCacheTypeFun}
                        setParty={setParty}
                        setGatePassInType={setGatePassInType}
                        setGatePassOutType={setGatePassOutType}
                        setPartyDetail={setPartyDetail}
                        setGpRgp={setGpRgp}
                        setGpNrgp={setGpNrgp}
                      />
                    </div>

                    {gatePassType?.label === "IN" && (
                      <div className="mb-2 w-full">
                        <label>
                          In Type{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <GatePassInTypeSelect
                          selectedOption={gatePassInType}
                          setSelectedOption={setGatePassInType}
                          setCacheInTypeFun={setCacheInTypeFun}
                          setParty={setParty}
                          // setPartyDetail={setPartyDetail}
                          // setCachePOFun={setCachePOFun}
                          setChoosePO={setChoosePO}
                        />
                      </div>
                    )}
                    {gatePassType?.label === "OUT" && (
                      <div className="mb-2 w-full">
                        <label>
                          Out Type{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <GatePassOutTypeSelect
                          selectedOption={gatePassOutType}
                          setSelectedOption={setGatePassOutType}
                          setCacheOutTypeFun={setCacheOutTypeFun}
                          setParty={setParty}
                          setGpNrgp={setGpNrgp}
                          setGpRgp={setGpRgp}
                        />
                      </div>
                    )}
                    {gatePassOutType?.label === "RGP" &&
                      gatePassType?.label === "OUT" && (
                        <div className="mb-2 w-full">
                          <label>
                            RGP{" "}
                            <span className="text-red-500 font-bold">*</span>
                          </label>
                          <GatePassRGPSelect
                            selectedOption={gpRgp}
                            setSelectedOption={setGpRgp}
                            getPartyDetailFun={getPartyDetailFun}
                            getRGPItemsFun={getRGPItemsFun}
                            setCachePOFun={setCachePOFun}
                            setCacheRgpFun={setCacheRgpFun}
                          />
                        </div>
                      )}
                    {gatePassOutType?.label === "NRGP" &&
                      gatePassType?.label === "OUT" && (
                        <div className="mb-2 w-full">
                          <label>
                            NRGP{" "}
                            <span className="text-red-500 font-bold">*</span>
                          </label>
                          <GatePassNRGPSelect
                            selectedOption={gpNrgp}
                            setSelectedOption={setGpNrgp}
                            getPartyDetailFun={getPartyDetailFun}
                            getNRGPItemsFun={getNRGPItemsFun}
                            setCachePOFun={setCachePOFun}
                            setCacheNRgpFun={setCacheNrgpFun}
                          />
                        </div>
                      )}
                    {gatePassOutType?.label === "RGP" &&
                      gatePassType?.label === "OUT" && (
                        <MyInput
                          label="Party"
                          type="text"
                          value={gpRgp?.party_id ? partyDetail : ""}
                          // onChange={(e) => setParty(e.target.value)}
                          className="w-full"
                          // mendatory="*"
                          readOnly
                        />
                      )}
                    {gatePassOutType?.label === "NRGP" &&
                      gatePassType?.label === "OUT" && (
                        <MyInput
                          label="Party"
                          type="text"
                          value={gpNrgp?.party_id ? partyDetail : ""}
                          // onChange={(e) => setParty(e.target.value)}
                          className="w-full"
                          // mendatory="*"
                          readOnly
                        />
                      )}
                    <MyInput
                      label="Gate No./Name"
                      type="text"
                      value={gateNo}
                      onChange={(e) => setGateNo(e.target.value)}
                      className="w-full"
                      // mendatory="*"
                      onBlur={() => setCacheFun()}
                    />
                    <MyInput
                      label="Vehicle No."
                      type="text"
                      value={vehicleNo}
                      onChange={(e) => setVehicleNo(e.target.value)}
                      className="w-full"
                      mendatory="*"
                      onBlur={() => setCacheFun()}
                    />
                    {/* <MyTextarea
                      label="Invoice/Challan Detail"
                      type="text"
                      className="w-full"
                      value={challan}
                      onChange={(e) => setChallan(e.target.value)}
                      onBlur={() => setCacheFun()}
                    /> */}
                    <MyInput
                      label="Visitor Name"
                      type="text"
                      value={visitorName}
                      onChange={(e) => setVisitorName(e.target.value)}
                      className="w-full"
                      mendatory="*"
                      onBlur={() => setCacheFun()}
                    />
                    <MyInput
                      label="Mobile"
                      type="text"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      className="w-full"
                      mendatory="*"
                      onBlur={() => setCacheFun()}
                    />
                    {gatePassInType?.label === "PO" && gatePassType?.label === "IN" && (
                      <div className="mb-2 w-full">
                        <label>
                          Choose PO{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <GatePassPOSelect
                          selectedOption={choosePO}
                          setSelectedOption={setChoosePO}
                          // selectedPOId={choosePO && choosePO.value}
                          getPartyDetailFun={getPartyDetailFun}
                          getPOItemsFun={getPOItemsFun}
                          setCachePOFun={setCachePOFun}
                        />
                      </div>
                    )}
                    {gatePassInType?.label === "PO" && (
                      <MyInput
                        label="Party"
                        type="text"
                        value={choosePO?.party_id ? partyDetail : ""}
                        // onChange={(e) => setParty(e.target.value)}
                        className="w-full"
                        // mendatory="*"
                        readOnly
                      />
                    )}
                    {gatePassInType?.label === "Direct" && (
                      <div className="mb-2 w-full">
                        <label>
                          Party{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <GatePassPartySelect
                          selectedOption={party}
                          setSelectedOption={setParty}
                          setCachePOFun={setCachePOFun}
                        />
                      </div>
                    )}

                    <MyTextarea
                      label="Remark"
                      type="text"
                      className="w-full"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      onBlur={() => setCacheFun()}
                    />
                  </div>
                </form>
              </div>
              {/* END LEFT PART  */}
            </div>
          </div>

          {/* Type:PO ITEM LIST FORM  */}
          {gatePassInType?.label === "PO" && (
            <div className="w-full px-2 mb-4">
              <GatePassPageForm
                editBtn={editBtn}
                // firstPageList={getUnsavedItemList}
                links={links}
                firstPage={gatePassListData}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                addMoreToggle={addMoreToggle}
                setAddMoreToggle={setAddMoreToggle}
                editDisable={editDisable}
                setPOItemCheckBoxId={setPOItemCheckBoxId}
                poItemCheckBoxId={poItemCheckBoxId}
                choosePO={choosePO}
                gatePassType={gatePassType}
              />
            </div>
          )}

          {/* RGP TABLE LIST  */}
          {gatePassOutType?.label === "RGP" &&
            gatePassType?.label === "OUT" && (
              <div className="w-full px-2 mb-4">
                <GatePassRGPPageForm
                  editBtn={editBtn}
                  // firstPageList={getUnsavedItemList}
                  links={links}
                  firstPage={gatePassListData}
                  setGetId={setGetId}
                  spinner={spinner}
                  totalNo={totalNo}
                  from={from}
                  to={to}
                  addMoreToggle={addMoreToggle}
                  setAddMoreToggle={setAddMoreToggle}
                  editDisable={editDisable}
                  setPOItemCheckBoxId={setPOItemCheckBoxId}
                  poItemCheckBoxId={poItemCheckBoxId}
                  choosePO={choosePO}
                  gatePassType={gatePassType}
                  gpNrgp={gpNrgp}
                  gpRgp={gpRgp}
                />
              </div>
            )}
          {/* NRGP TABLE LIST  */}
          {gatePassOutType?.label === "NRGP" &&
            gatePassType?.label === "OUT" && (
              <div className="w-full px-2 mb-4">
                <GatePassNRGPPageForm
                  editBtn={editBtn}
                  // firstPageList={getUnsavedItemList}
                  links={links}
                  firstPage={gatePassListData}
                  setGetId={setGetId}
                  spinner={spinner}
                  totalNo={totalNo}
                  from={from}
                  to={to}
                  addMoreToggle={addMoreToggle}
                  setAddMoreToggle={setAddMoreToggle}
                  editDisable={editDisable}
                  setPOItemCheckBoxId={setPOItemCheckBoxId}
                  poItemCheckBoxId={poItemCheckBoxId}
                  choosePO={choosePO}
                  gatePassType={gatePassType}
                  gpNrgp={gpNrgp}
                  gpRgp={gpRgp}
                />
              </div>
            )}

          {gatePassInType?.label === "Direct" && party?.value && (
            <DirectGPCreateForm
              partyId={party?.value}
              setCacheInTypeFun={setCacheInTypeFun}
              getUnsavedItemList={getUnsavedItemList}
              setUnsavedIndentItem={setUnsavedIndentItem}
              unsavedIndentItem={unsavedIndentItem}
            />
          )}

          {submitAction === "submit" && gatePassInType?.label === "PO" && gatePassType?.label=== "IN" && (
            <div className="flex items-center justify-center gap-x-1 mt-2">
              <Button
                type="submit"
                // disabled={submitDisable || unsavedIndentItem.length <= 0}
                disabled={submitDisable}
                onClick={(e) => createDivision(e)}
              >
                {submitDisable ? "Wait.." : "Submit"}
              </Button>
              <Button type="button" onClick={() => cancelUpdate()}>
                Clear
              </Button>
            </div>
          )}
          {submitAction === "submit" && gatePassOutType?.label === "RGP" && gatePassType?.label==="OUT" && (
            <div className="flex items-center justify-center gap-x-1 mt-2">
              <Button
                type="submit"
                // disabled={submitDisable || unsavedIndentItem.length <= 0}
                disabled={submitDisable}
                onClick={(e) => rgpSubmitFuc(e)}
              >
                {submitDisable ? "Wait.." : "Submit"}
              </Button>
              <Button type="button" onClick={() => cancelUpdate()}>
                Clear
              </Button>
            </div>
          )}
          {submitAction === "submit" && gatePassOutType?.label === "NRGP" && (
            <div className="flex items-center justify-center gap-x-1 mt-2">
              <Button
                type="submit"
                // disabled={submitDisable || unsavedIndentItem.length <= 0}
                disabled={submitDisable}
                onClick={(e) => nrgpSubmitFuc(e)}
              >
                {submitDisable ? "Wait.." : "Submit"}
              </Button>
              <Button type="button" onClick={() => cancelUpdate()}>
                Clear
              </Button>
            </div>
          )}
          {submitAction === "submit" &&
            gatePassInType?.label === "Direct" &&
            party?.value && (
              <div className="flex items-center justify-center gap-x-1">
                <Button
                  type="submit"
                  // disabled={submitDisable || unsavedIndentItem.length <= 0}
                  disabled={submitDisable}
                  onClick={(e) => createDirectGP(e)}
                >
                  {submitDisable ? "Wait.." : "Submit"}
                </Button>
                <Button type="button" onClick={() => cancelUpdate()}>
                  Clear
                </Button>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}
